import {
  StyledContainer,
  StyledErrorMessage,
  StyledErrorRounded,
} from './styled';

interface PropsType {
  message: string;
}
const ErrorMessagesContainer = ({ message }: PropsType) => (
  <StyledContainer>
    <StyledErrorRounded />
    <StyledErrorMessage>{message}</StyledErrorMessage>
  </StyledContainer>
);

export default ErrorMessagesContainer;
